import Vue from 'vue';
import App from './App.vue';
import router from './router';
import { baseTitle } from './router';
import vuetify from './plugins/vuetify';
import store from './store';
import axios from '../node_modules/axios/dist/axios';
import gtagHelpers from './gtagHelpers';

Vue.config.productionTip = false;
Vue.prototype.$gtag = gtagHelpers;
Vue.prototype.$baseTitle = baseTitle;
Vue.prototype.$appName = 'TeamHive'; // probably the same as baseTitle, but might be different.


//let localURL = 'http://teamhive.test:8000/api/Broadcast/Broadcast/';
let localURL = 'http://teamhive-management.test:8000/api/Broadcast/Broadcast/';
let prodURL = 'https://manage.teamhive.live/api/Broadcast/Broadcast/';

if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
  axios.defaults.baseURL = localURL;
} else {
  axios.defaults.baseURL = prodURL;
}

window.axios = axios;

window.axios.interceptors.response.use(response => {
  if (response.data.success !== undefined) {
    if (response.data.success === false && response.data.message !== undefined) {
      store.dispatch('addSnackbar', {
        text: response.data.message,
        color: 'error',
      });
      gtagHelpers.experience('server_error', response.data.message);
    } else if (response.data.success === true && response.data.message !== undefined) {
      store.dispatch('addSnackbar', {
        text: response.data.message,
        color: 'success',
      });
      gtagHelpers.experience('server_success', response.data.message);
    }
  }
  return response;
});

const files = require.context('./components', true, /\.vue$/i);
files.keys().map(key => {
  Vue.component(
    key
      .split('/')
      .pop()
      .split('.')[0],
    files(key).default,
  );
});

new Vue({
  router,
  vuetify,
  store,
  render: h => h(App),
}).$mount('#app');
